import { render, staticRenderFns } from "./SZ_homePageReportNew.vue?vue&type=template&id=52148cff&scoped=true&"
import script from "./SZ_homePageReportNew.vue?vue&type=script&lang=js&"
export * from "./SZ_homePageReportNew.vue?vue&type=script&lang=js&"
import style0 from "./SZ_homePageReportNew.vue?vue&type=style&index=0&id=52148cff&prod&scoped=true&lang=css&"
import style1 from "./SZ_homePageReportNew.vue?vue&type=style&index=1&id=52148cff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52148cff",
  null
  
)

export default component.exports